import { TableFilterClub } from "../../common/enums/common.enums";
import { IChartInfo } from "../../common/interfaces/chart.interface";
import {
  IClubsOverview,
  IClubsTableInfo,
} from "../../common/interfaces/club.interface";
import { get } from "../utilities/http";
import {
  CLUBS_CHART_INFO,
  CLUBS_OVERVIEW,
  CLUBS_TABLE_INFO,
} from "../utilities/urls";

export function getClubsOverview(): Promise<IClubsOverview> {
  return get(CLUBS_OVERVIEW);
}

export function getClubsChartInfo(): Promise<IChartInfo> {
  return get(CLUBS_CHART_INFO);
}

export function getClubsTableInfo(
  criteria: TableFilterClub
): Promise<IClubsTableInfo[]> {
  return get(`${CLUBS_TABLE_INFO}?criteria=${criteria}&limit=5`);
}
